<template>
  <section class="info-recommend-charge">
    <div class="card shadow">
      <div class="card-body pb-0">

        <div class="row mb-3">
          <card-title class="col" icon-image="mdi-hand-pointing-right" title="충전기 추천 서비스" text-color="title" />
        </div>

        <!--  Recommend By Time Zone Start  -->
        <div class="card">
          <div class="row">
            <div class="card-body col-xl-8 align-content-center pb-0">
              <div class="row justify-content-between">
                <div class="col-8">
                  <card-title class="fs-6" title="추천1. 선호 시간 기준" text-color="title"/>
                </div>
                <div class="col-4 text-end">
                  <span class="icon-padding-right">추천 기준</span>
                  <span class="font-size-18" id="recommend1-info-tooltip">
                    <i class="mdi mdi-comment-question ct-text-main"/>
                  </span>
                  <b-tooltip target="recommend1-info-tooltip" placement="right" custom-class="desc-tooltip">
                    <pre class="pre-tag-tooltip">{{ recommend1 }}</pre>
                  </b-tooltip>
                </div>
              </div>
              <hr class="my-0"/>
              <div class="row">
                <div class="card-body col-lg-6">
                  <div class="border border-1 shadow p-3">
                    <div class="row d-flex justify-content-center mt-3 mb-5">
                      <div class="col-6 text-center py-2 bg-ev-green-gradient rounded">
                        <span class="text-white font-size-20 fw-bold">{{ recmdByTime.preferredTime }}</span>
                      </div>
                    </div>

                    <div class="d-flex flex-wrap justify-content-between mb-4">
                      <b-button v-for="(day, i) in recmdByTime.weekDayBtns"
                                class="dayBtn mb-1"
                                :variant="day.color" :disabled="day.disabled">
                        {{ day.captions }}
                      </b-button>
                    </div>
                    <div class="text-end">
                      <span>* 주요 충전 요일</span>
                    </div>
                  </div>
                </div>
                <div class="card-body col-lg-6">
                  <div>
                    <b-table class="datatables text-nowrap text-center align-middle"
                             tbody-class="fw-bold"
                             :fields="recmdSuccessRateFields" :items="recmdByTime.recmdTimeItems">

                      <template #cell(type)="data">
                        <div v-if="Number(data.item.type) === 2">
                          <img src="@/assets/images/charger-gray.png" alt="not used charger" height="30">
                        </div>
                        <div v-else>
                          <img src="@/assets/images/charger-color.png" alt="used charger" height="30">
                        </div>
                      </template>
                      <template #cell(successRate)="data">
                        <div class="text-danger fs-4">
                          {{ data.item.successRate }} <span class="fs-6">%</span>
                        </div>
                      </template>
                    </b-table>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body col-xl-4">
              <card-title class="fs-6" title="예상 충전 성공률 비교" text-color="title"/>
              <div class="border border-1 px-3 me-2">
                <apexchart ref="recommendByTimeChart" height="240" :options="recommendByTimeChartOptions"
                           :series="recommendByTimeChartOptions.series"/>
              </div>
            </div>
          </div>
        </div>
        <!--  Recommend By Time Zone End  -->

        <!--  Recommend By Day Zone Start  -->
        <div class="card">
          <div class="row">
            <div class="card-body col-xl-8 align-content-center pb-0">
              <div class="row justify-content-between">
                <div class="col-8">
                  <card-title class="fs-6" title="추천2. 선호 요일 기준" text-color="title"/>
                </div>
                <div class="col-4 text-end">
                  <span class="icon-padding-right">추천 기준</span>
                  <span class="font-size-18" id="recommend2-info-tooltip">
                    <i class="mdi mdi-comment-question ct-text-main"/>
                  </span>
                  <b-tooltip target="recommend2-info-tooltip" placement="right" custom-class="desc-tooltip">
                    <pre class="pre-tag-tooltip">{{ recommend2 }}</pre>
                  </b-tooltip>
                </div>
              </div>
              <hr class="my-0"/>
              <div class="row">
                <div class="card-body col-lg-6">
                  <div class="border border-1 shadow p-3">
                    <div class="row d-flex justify-content-center mt-3 mb-5">
                      <div class="col-6 text-center py-2 bg-ev-green-gradient rounded">
                        <span class="text-white font-size-20 fw-bold">{{ recmdByDay.preferredDay }}</span>
                      </div>
                    </div>

                    <div class="d-flex flex-wrap justify-content-between mb-2">
                      <div v-for="(time, i) in recmdByDay.timeBtns">
                        <b-button class="timeBtn pe-1 mb-1" size="sm"
                                  :variant="time.color" :disabled="time.disabled"
                                  :title="time.title">
                        </b-button>

                        <div class="hour-text">{{ i % 6 == 0 ? i : null }}</div>
                      </div>
                    </div>
                    <div class="text-end">
                      <span>* 주요 충전 시간</span>
                    </div>
                  </div>
                </div>
                <div class="card-body col-lg-6">
                  <div>
                    <b-table class="datatables text-nowrap text-center align-middle"
                             tbody-class="fw-bold"
                             :fields="recmdSuccessRateFields" :items="recmdByDay.recmdDayItems">

                      <template #cell(type)="data">
                        <div v-if="Number(data.item.type) === 2">
                          <img src="@/assets/images/charger-gray.png" alt="not used charger" height="30">
                        </div>
                        <div v-else>
                          <img src="@/assets/images/charger-color.png" alt="used charger" height="30">
                        </div>
                      </template>
                      <template #cell(successRate)="data">
                        <div class="text-danger fs-4">
                          {{ data.item.successRate }} <span class="fs-6">%</span>
                        </div>
                      </template>
                    </b-table>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body col-xl-4">
              <card-title class="fs-6" title="예상 충전 성공률 비교" text-color="title"/>
              <div class="border border-1 px-3 me-2">
                <apexchart ref="recommendByDayChart" height="240" :options="recommendByDayChartOptions"
                           :series="recommendByDayChartOptions.series"/>
              </div>
            </div>
          </div>
        </div>
        <!--  Recommend By Day Zone End  -->

        <!--  Recommend By Cost Start  -->
        <div class="card">
          <div class="row">
            <div class="card-body col-xl-8 align-content-center pb-0">
              <div class="row justify-content-between">
                <div class="col-8">
                  <card-title class="fs-6" title="추천3. 요금 절감 기준" text-color="title"/>
                </div>
                <div class="col-4 text-end">
                  <span class="icon-padding-right">추천 기준</span>
                  <span class="font-size-18" id="recommend3-info-tooltip">
                    <i class="mdi mdi-comment-question ct-text-main"/>
                  </span>
                  <b-tooltip target="recommend3-info-tooltip" placement="right" custom-class="desc-tooltip">
                    <pre class="pre-tag-tooltip">{{ recommend3 }}</pre>
                  </b-tooltip>
                </div>
              </div>
              <hr class="my-0"/>
              <div class="row">
                <div class="card-body col-lg-6">
                  <div class="border border-1 shadow p-3">
                    <h6 class="mb-2">충전요금 절감 가능 이력</h6>
                    <div class="common-sticky-table">
                      <b-table ref="reducibleHistoryTable"
                               class="datatables text-nowrap"
                               hover outlined show-empty
                               responsive sticky-header="180px"
                               selectable select-mode="single"
                               :fields="recmdByCost.reducibleHistoryFields"
                               :items="recmdByCost.reducibleHistoryItems"
                               @row-clicked="checkSelected"
                               @row-selected="changeRecmdCostbyHistory">
                        <template #empty="scope">
                          <span>No Data</span>
                        </template>
                      </b-table>
                    </div>
                  </div>
                </div>
                <div class="card-body col-lg-6">
                  <div>
                    <b-table class="datatables text-nowrap text-center align-middle"
                             tbody-class="fw-bold"
                             :fields="recmdSuccessRateFields" :items="recmdByCost.recmdSuccessRateItems">

                      <template #cell(type)="data">
                        <div v-if="Number(data.item.type) === 2">
                          <img src="@/assets/images/charger-gray.png" alt="not used charger" height="30">
                        </div>
                        <div v-else>
                          <img src="@/assets/images/charger-color.png" alt="used charger" height="30">
                        </div>
                      </template>
                      <template #cell(successRate)="data">
                        <div class="text-danger fs-4">
                          {{ data.item.successRate }} <span class="fs-6">%</span>
                        </div>
                      </template>
                    </b-table>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body col-xl-4">
              <card-title class="fs-6" title="추천 시간 및 요금 구간" text-color="title"/>
              <div class="border border-1 me-2 mb-3">
                <apexchart ref="recommendByCostChart" height="140" :options="recommendByCostChartOptions"
                           :series="recommendByCostChartOptions.series"/>
              </div>
              <div class="mt-2 me-2 p-3 rounded-4 border border-3 border-ev-green shadow">
                <div class="row">
                  <div class="col-3 offset-1">
                    <div class="text-center fw-bold text-black align-middle">
                      <div class="mb-1">
                        절감 금액
                      </div>
                      <div :class="recmdByCost.recmdCostResultItems[0] === recmdByCost.recmdCostResultItems[1]
                            ? 'text-dark-50'
                            : 'text-danger fs-4'">
                        {{ recmdByCost.savedCost }} 원
                      </div>
                    </div>

                  </div>
                  <table class="col-8 text-center text-black align-middle">
                    <thead>
                    <b-tr>
                      <th v-for="(field, i) in recmdByCost.recmdCostResultFields">
                        {{ field }}
                      </th>
                    </b-tr>
                    </thead>
                    <b-tbody class="fw-bold">
                      <b-tr>
                        <b-td class="cost-color1">
                          {{ recmdByCost.recmdCostResultItems[0] }}원
                        </b-td>
                        <b-td class="cost-color2">
                          {{ recmdByCost.recmdCostResultItems[1] }}원
                        </b-td>
                      </b-tr>
                    </b-tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--  Recommend By Cost Zone End  -->

      </div>
    </div>
  </section>
</template>

<script>
import CardTitle from "@/views/components/cardTitle.vue";
import { http } from "@/mdk/auth-api";

export default {
  components: { CardTitle },
  props: {
    searchArgs: Object
  },
  data() {
    return {
      weekDays: [ '월', '화', '수', '목', '금', '토', '일' ],
      recmdSuccessRateFields: [
        { key: 'type', label: '' },
        { key: 'csoEvseNum', label: '추천 충전기' },
        { key: 'successRate', label: '예상 충전 성공률' }
      ],
      recommendByTimeData: null,
      recmdByTime: {
        preferredTime: '선호 시간',
        weekDayBtns: [],
        recmdTimeFields: [ '', '추천 충전기', '예상 충전 성공률' ],
        recmdTimeItems: [],
      },
      recommendByDayData: null,
      recmdByDay: {
        preferredDay: '선호 요일',
        timeBtns: [],
        recmdDayFields: [ '', '추천 충전기', '예상 충전 성공률' ],
        recmdDayItems: [],
      },
      recommendByCostData: null,
      recmdByCost: {
        reducibleHistoryFields: [
          { key: 'baseDate', label: '충전일' },
          { key: 'csoEvseNum', label: '충전기' },
          { key: 'baseCost', label: '충전요금' }
        ],
        reducibleHistoryItems: [],
        recmdSuccessRateItems: [],
        recmdCostResultFields: [ '기존 충전 금액', '예상 충전 금액' ],
        recmdCostResultItems: [],
        savedCost: null,
      },
      recommendByTimeChartOptions: {
        chart: {
          type: 'line',
          toolbar: { show: false },
          zoom: { enabled: false },
          fontFamily: 'NanumSquareRound',
        },
        xaxis: {
          categories: ['월', '화', '수', '목', '금', '토', '일',''],
          tickPlacement: 'between',
          labels: {
            hideOverlappingLabels: false,
          },
          tooltip: { enabled: false },
        },
        yaxis: [
          {
            seriesName: '충전 성공률',
            min: 0,
            max: 100,
            tickAmount: 4,
            title: {
              text: "충전 성공률",
              style: {
                fontWeight: 600,
              }
            },
          }
        ],
        fill: {
          opacity: 1,
          colors: [ '#36a8ff', '#380072' ],
        },
        stroke: {
          width: 1,
        },
        markers: {
          size: 2,
          strokeWidth: 0,
          hover: {
            sizeOffset: 3
          }
        },
        dataLabels: { enabled: false },
        legend: {
          markers: {
            width: 12,
            height: 2,
          },
        },
        grid: {
          padding: {
            right: -50,
          },
        },
        tooltip: {
          enabled: true,
          x: {
            formatter: x => `${x}요일`,
          },
          y: {
            formatter: y => `${y}%`
          }
        },
        annotations: {
          xaxis: [],
        },
        series: [],
        noData: {
          text: 'No Data',
          offsetY: -25,
          style: {
            color: '#9599AD',
            fontSize: '15px',
          }
        },
      },
      recommendByDayChartOptions: {
        chart: {
          type: 'line',
          toolbar: { show: false },
          zoom: { enabled: false },
          fontFamily: 'NanumSquareRound',
        },
        xaxis: {
          categories: [ ...Array.from({ length: 24 }, (v, i) => i), '' ],
          labels: {
            hideOverlappingLabels: false,
          },
          tickPlacement: 'between',
          tooltip: { enabled: false },
        },
        yaxis: [
          {
            seriesName: '충전 성공률',
            min: 0,
            max: 100,
            tickAmount: 4,
            title: {
              text: "충전 성공률",
              style: {
                fontWeight: 600,
              }
            },
          }
        ],
        fill: {
          opacity: 1,
          colors: [ '#36a8ff', '#380072' ],
        },
        stroke: {
          width: 1,
        },
        markers: {
          size: 2,
          strokeWidth: 0,
          hover: {
            sizeOffset: 3
          }
        },
        dataLabels: { enabled: false },
        legend: {
          markers: {
            width: 12,
            height: 2,
          },
        },
        grid: {
          padding: {
            right: -15,
          },
        },
        tooltip: {
          enabled: true,
          x: {
            formatter: x => `${x}시 ~ ${x+1}시`,
          },
          y: {
            formatter: y => `${y}%`,
          }
        },
        annotations: {
          xaxis: [],
        },
        series: [],
        noData: {
          text: 'No Data',
          offsetY: -25,
          style: {
            color: '#9599AD',
            fontSize: '15px',
          }
        },
      },
      recommendByCostChartOptions: {
        chart: {
          type: 'rangeBar',
          toolbar: { show: false },
          zoom: { enabled: false },
          fontFamily: 'NanumSquareRound',
        },
        plotOptions: {
          bar: {
            horizontal: true,
            distributed: true,
            rangeBarGroupRows: true,
            dataLabels: {
              hideOverflowingLabels: false
            }
          }
        },
        dataLabels: { enabled: false },
        legend: {
          show: false,
          position: 'top',
          horizontalAlign: 'right',
          customLegendItems: [],
          markers: {
            width: 12,
            height: 10,
            fillColors: ['#FFD074B2', '#FF8858B2'],
            radius: 0,
          },
        },
        xaxis: {
          type: 'numeric',
          min: 0,
          max: 24,
          tickAmount: 4,
          decimalsInFloat: 0,
          labels: {
            formatter: val => `${val}:00`
          }
        },
        series: [
          { data: [{
              x: '기존 충전 시간대',
              y: []
            }]
          },
          { data: [{
              x: '추천 충전 시간대',
              y: []
            }]
          }
        ],
        noData: {
          text: 'No Data',
          style: {
            color: '#9599AD',
            fontSize: '15px',
          }
        },
        annotations: {
          xaxis: [],
        },
        tooltip: {
          x: {
            formatter: x => x
          },
          y: {
            formatter: y => `${y}시`,
          }
        },
      },
      recommend1: '',
      recommend2: '',
      recommend3: '',
    }
  },
  watch: {
    searchArgs: {
      deep: true,
      handler(val) {
        const vm = this;

        vm.clear();
        vm.getRecmdTimeAndDayData();
        vm.getRecmdCostData();
      },
    },
  },
  mounted() {
    const vm = this;

    vm.recmdByTime.weekDayBtns = Array.from({ length: 7 }, (v, i) => (
      { captions: vm.weekDays[i], disabled: true }
    ));
    vm.recmdByDay.timeBtns = Array.from({ length: 24 }, (v, i) => (
      { disabled: true }
    ));
    vm.recommend1 =
      `• 한 달간 가장 자주 충전한 선호 시간에
  이용 빈도가 높았던 요일을 산출하여
  해당 구간에 높은 확률로 충전이 가능한 충전기를 추천함.

• 추천 충전기는 사용 이력이 있는 충전기 중에서
  충전 성공률이 높은 순서로 TOP3를 추천함.
  (충전기 이용 경험 우선)`;
    vm.recommend2 =
      `• 한 달간 가장 자주 충전한 선호 요일에
  이용 빈도가 높았던 시간을 산출하여
  해당 구간에 높은 확률로 충전이 가능한 충전기를 추천함.

• 추천 충전기는 사용 이력이 있는 충전기 중에서
  충전 성공률이 높은 순서로 TOP3를 추천함.
  (충전기 이용 경험 우선)`;
    vm.recommend3 =
      `• 한 달간의 충전 이력에 대해
  충전 시간대 이동으로 얻을 수 있는 요금 절감 효과를 보여줌.

• 추천 충전기는 사용 이력이 없더라도 전체 충전기 중에서
  충전 성공률이 높은 순서로 TOP3를 추천함.
  (요금 절감 우선)`;
  },
  methods: {
    async getRecmdTimeAndDayData() {
      const vm = this;
      const _url = `/onmapi/charging-service/recommend`;

      try {
        const res = await http.get(_url, {
          params: {
            targetMonth: moment(vm.searchArgs.month).format('YYYY-MM'),
            userId: vm.searchArgs.userId,
            placeId: vm.searchArgs.stationId
          }
        });

        vm.recommendByTimeData = { ...res.data.items.baseOnTime };
        vm.recommendByDayData =  { ...res.data.items.baseOnDay } ;
        vm.updateRecmdTime();
        vm.updateRecmdDay();


      } catch(err) {
        console.error(err)
      }
    },
    async getRecmdCostData() {
      const vm = this;
      const _url = `/onmapi/charging-service/save-cost`;

      try {
        const res = await http.get(_url, {
          params: {
            targetMonth: moment(vm.searchArgs.month).format('YYYY-MM'),
            userId: vm.searchArgs.userId,
            placeId: vm.searchArgs.stationId
          }
        });

        vm.recommendByCostData = [ ...res.data.items ];

        if (vm.recommendByCostData.length > 0) {
          vm.updateRecmdCost();
        };
      } catch(err) {
        console.error(err)
      }
    },
    updateRecmdTime() {
      const vm = this;

      const preferredTime = vm.recommendByTimeData.recommendEvse[0].hour;
      vm.recmdByTime.preferredTime = `${preferredTime[0]}시 ~ ${preferredTime.slice(-1)[0] + 1}시`;

      const recmdDayIdx = vm.recommendByTimeData.recommendEvse[0].dayOfWeek - 1;
      vm.recmdByTime.weekDayBtns = vm.weekDays.map((ele, i) => {
        if (i === recmdDayIdx) {
          return { captions: ele, disabled: false, color: 'warning' }
        } else {
          return { captions: ele, disabled: true }
        }
      })

      vm.recmdByTime.recmdTimeItems = vm.recommendByTimeData.recommendEvse;

      const dayAnnotationsProperty = [{
        x: vm.weekDays[recmdDayIdx],
        x2: vm.weekDays[recmdDayIdx] === '일' ? '' : vm.weekDays[recmdDayIdx + 1],
        fillColor: 'rgba(255,208,116,0.7)',
        strokeDashArray: 0,
        borderWidth: 0,
        borderColor: 'rgba(255,255,255,0)',
        opacity: 0.4,
        offsetX: -28,
        label: {
          text: '주요 충전 요일',
          position: 'bottom',
          offsetY: -10,
          orientation: 'horizontal',
          borderColor: 'rgba(255,208,116,0.7)',
          style: {
            fontSize: '10px',
            color: '#fff',
            background: '#ffbf30',
          },
        }
      }];

      vm.$refs.recommendByTimeChart.updateOptions({
        annotations: { xaxis: dayAnnotationsProperty }
      });

      vm.recmdByTime = { ...vm.recmdByTime };
      vm.updateRecommendByTimeChart();
    },
    updateRecmdDay() {
      const vm = this;

      vm.recmdByDay.preferredDay = `${vm.recommendByDayData.recommendEvse[0].day}요일`;

      const recmdTimeIdxArr = vm.recommendByDayData.recommendEvse[0].hour;
      vm.recmdByDay.timeBtns = Array.from({ length: 24 }).map((ele, i) => {
        if (recmdTimeIdxArr.includes(i)) {
          return {
            disabled: false,
            color: 'warning',
            id: 'preferred-hour',
            title: `${recmdTimeIdxArr[0]}시 ~ ${recmdTimeIdxArr.slice(-1)[0] + 1}시`,
            tooltip: true
          }
        } else {
          return {
            disabled: true
          }
        }
      });

      vm.recmdByDay.recmdDayItems = vm.recommendByDayData.recommendEvse;

      const timeAnnotationsProperty = [];

      if ( Number(recmdTimeIdxArr.slice(-1)[0]) + 1 > Number(recmdTimeIdxArr[0]) ) {
        timeAnnotationsProperty.push({
          x: recmdTimeIdxArr[0],
          x2: recmdTimeIdxArr.slice(-1)[0] === 23 ? '' : recmdTimeIdxArr.slice(-1)[0] + 1,
          fillColor: 'rgba(255,208,116,0.7)',
          strokeDashArray: 0,
          borderWidth: 0,
          borderColor: 'rgba(255,255,255,0)',
          opacity: 0.4,
          offsetX: -10,
          label: {
            text: '주요 충전 시간',
            position: 'bottom',
            offsetX: 10,
            offsetY: -9,
            orientation: 'horizontal',
            borderColor: 'rgba(255,208,116,0.7)',
            style: {
              fontSize: '10px',
              color: '#fff',
              background: '#ffbf30',
            },
          }
        });
      } else {
        timeAnnotationsProperty.push({
          x: recmdTimeIdxArr[0],
          x2: 24,
          fillColor: 'rgba(255,208,116,0.7)',
          strokeDashArray: 0,
          borderWidth: 0,
          borderColor: 'rgba(255,255,255,0)',
          opacity: 0.4,
          offsetX: -10,
          label: {
            text: '주요 충전 시간',
            position: 'bottom',
            offsetX: 10,
            offsetY: -9,
            orientation: 'horizontal',
            borderColor: 'rgba(255,208,116,0.7)',
            style: {
              fontSize: '10px',
              color: '#fff',
              background: '#ffbf30',
            },
          }
        },{
          x: 0,
          x2: recmdTimeIdxArr.slice(-1)[0] === 23 ? '' : recmdTimeIdxArr.slice(-1)[0] + 1,
          fillColor: 'rgba(255,208,116,0.7)',
          strokeDashArray: 0,
          borderWidth: 0,
          borderColor: 'rgba(255,255,255,0)',
          opacity: 0.4,
          offsetX: -10,
          label: {
            text: '주요 충전 시간',
            position: 'bottom',
            offsetX: 10,
            offsetY: -9,
            orientation: 'horizontal',
            borderColor: 'rgba(255,208,116,0.7)',
            style: {
              fontSize: '10px',
              color: '#fff',
              background: '#ffbf30',
            },
          }
        })
      }

      vm.$refs.recommendByDayChart.updateOptions({
        annotations: { xaxis: timeAnnotationsProperty }
      });

      vm.recmdByDay = { ...vm.recmdByDay };
      vm.updateRecommendByDayChart();
    },
    updateRecmdCost() {
      const vm = this;

      // update Table
      vm.recmdByCost.reducibleHistoryItems = vm.recommendByCostData.map((ele, i) => {
        const baseDate = moment(`${ele.baseDate}-${ele.startTime.slice(3)}`).locale('ko').format('M월D일(ddd)');
        const csoEvseNum = ele.csoEvseNum;
        const baseCost = ele.baseCost.toLocaleString();

        return { baseDate, csoEvseNum, baseCost, index: i }
      });
      this.$nextTick(() => this.$refs.reducibleHistoryTable.selectRow(0));

      // update Chart annotations
      const seasonFeeSection = {
        xaxis: [{
          x: 0,
          x2: 8,
          fillColor: '#FFD074B2',
          strokeDashArray: 0,
          borderColor: '#FFFFFF00',
          opacity: 0.3,
        }, {
          x: 8,
          x2: 22,
          fillColor: '#FF8858B2',
          strokeDashArray: 0,
          borderColor: '#FFFFFF00',
          opacity: 0.3,
        }, {
          x: 22,
          x2: 24,
          fillColor: '#FFD074B2',
          strokeDashArray: 0,
          borderColor: '#FFFFFF00',
          opacity: 0.3,
        }]
      };

      this.$refs.recommendByCostChart.updateOptions({ annotations : seasonFeeSection });
    },
    checkSelected(item, i) {
      const vm = this;

      if (this.$refs.reducibleHistoryTable.isRowSelected(i)) {
        this.$nextTick(() => this.$refs.reducibleHistoryTable.selectRow(i));
      }
    },
    changeRecmdCostbyHistory(row) {
      const vm = this;
      console.log(row)

      if (row.length > 0) {
        const rowIdx = row[0].index;

        vm.recmdByCost.recmdSuccessRateItems = vm.recommendByCostData[rowIdx].evseList.slice(0, 3);
        vm.recmdByCost.recmdCostResultItems = [ vm.recommendByCostData[rowIdx].baseCost.toLocaleString(), vm.recommendByCostData[rowIdx].minCost.toLocaleString() ];
        vm.recmdByCost.savedCost = ( Number(vm.recommendByCostData[rowIdx].baseCost) - Number(vm.recommendByCostData[rowIdx].minCost) ).toLocaleString();

        vm.recmdByCost = { ...vm.recmdByCost };
        vm.updateRecommendByCostChart(rowIdx);
      }
    },
    updateRecommendByTimeChart() {
      const vm = this;

      const chartSeries = [];

      vm.recmdByTime.recmdTimeItems.forEach((ele, i) => {
        const recommandEvseNum = ele.csoEvseNum;
        const recommandEvseData = vm.recommendByTimeData.successRateComparison.find(data =>
          data.csoEvseNum === recommandEvseNum
        );
        chartSeries.push({ name: `추천${i + 1} (${recommandEvseNum})`, data: recommandEvseData.daySuccessRate });
      })
      chartSeries.push({ name: '그 외 충전기 평균', data: vm.recommendByTimeData.successRateComparison[0].daySuccessRate, color: '#a8a8a8' });

      vm.$refs.recommendByTimeChart.updateSeries(chartSeries);
    },
    updateRecommendByDayChart() {
      const vm = this;

      const chartSeries = [];
      const strokeColors = [ '#008FFB',	'#00E396',	'#FEB019' ];

      vm.recmdByDay.recmdDayItems.forEach((ele, i) => {
        const recommandEvseNum = ele.csoEvseNum;
        const recommandEvseData = vm.recommendByDayData.successRateComparison.find(data =>
          data.csoEvseNum === recommandEvseNum
        );
        chartSeries.push({ name: `추천${i + 1} (${recommandEvseNum})`, data: recommandEvseData.hourSuccessRate, color: strokeColors[i] });
      });
      chartSeries.push({ name: '그 외 충전기 평균', data: vm.recommendByDayData.successRateComparison.slice(-1)[0].hourSuccessRate, color: '#a8a8a8' });

      vm.$refs.recommendByDayChart.updateSeries(chartSeries);
    },
    updateRecommendByCostChart(i) {
      const vm = this;

      const baseData = [];
      const minData = [];
      const currentMonth = new Date().getMonth() + 1;

      if ( Number(vm.recommendByCostData[i].baseHour.slice(-1)[0]) + 1 > Number(vm.recommendByCostData[i].baseHour[0]) ) {
        baseData.push(
          {
            x: '기존 충전 시간대',
            y: [
              Number(vm.recommendByCostData[i].baseHour[0]),
              Number(vm.recommendByCostData[i].baseHour.slice(-1)[0]) + 1
            ],
            fillColor: '#008FFB'
          }
        )
      } else {
        baseData.push(
          {
            x: '기존 충전 시간대',
            y: [
              Number(vm.recommendByCostData[i].baseHour[0]),
              24
            ],
            fillColor: '#008FFB'
          }, {
            x: '기존 충전 시간대',
            y: [
              0,
              Number(vm.recommendByCostData[i].baseHour.slice(-1)[0]) + 1
            ],
            fillColor: '#008FFB'
          }
        )
      }

      if ( Number(vm.recommendByCostData[i].minHour.slice(-1)[0]) + 1 > Number(vm.recommendByCostData[i].minHour[0]) ) {
        minData.push(
          {
            x: '추천 충전 시간대',
            y: [
              Number(vm.recommendByCostData[i].minHour[0]),
              Number(vm.recommendByCostData[i].minHour.slice(-1)[0]) + 1
            ],
            fillColor: '#00E396'
          }
        )
      } else {
        minData.push(
          {
            x: '추천 충전 시간대',
            y: [
              Number(vm.recommendByCostData[i].minHour[0]),
              24
            ],
            fillColor: '#00E396'
          }, {
            x: '추천 충전 시간대',
            y: [
              0,
              Number(vm.recommendByCostData[i].minHour.slice(-1)[0]) + 1
            ],
            fillColor: '#00E396'
          }
        )
      };

      const costLegend = [];
      if ((currentMonth >= 3 && currentMonth <= 5) || (currentMonth >= 9 && currentMonth <= 10)) {
        costLegend.push('197.5원', '197.5원');
      } else if (currentMonth >= 6 && currentMonth <= 8) {
        costLegend.push('208.4원', '254원');
      } else {
        costLegend.push('219.3원', '240.9원');
      }

      vm.$refs.recommendByCostChart.updateOptions({
        xaxis: {
          type: 'numeric',
          min: 0,
          max: 24,
          tickAmount: 4,
        },
        legend: {
          show: true,
          customLegendItems: costLegend
        },
        series: [{ data: baseData },
          { data: minData }]
      });

      console.log({
        xaxis: {
          type: 'numeric',
          min: 0,
          max: 24,
          tickAmount: 4,
        },
        legend: {
          show: true,
          customLegendItems: costLegend
        },
        series: [{ data: baseData },
          { data: minData }]
      })
    },
    clear() {
      const vm = this;

      vm.recmdByTime = {
        preferredTime: '선호 시간',
          weekDayBtns: Array.from({ length: 7 }, (v, i) => ({ captions: vm.weekDays[i], disabled: true })),
          recmdTimeFields: [ '', '추천 충전기', '예상 충전 성공률' ],
          recmdTimeItems: [],
      };
      vm.recmdByDay = {
        preferredDay: '선호 요일',
        timeBtns: Array.from({ length: 24 }, (v, i) => ({ disabled: true })),
        recmdDayFields: [ '', '추천 충전기', '예상 충전 성공률' ],
        recmdDayItems: [],
      };
      vm.recmdByCost = {
        reducibleHistoryFields: [
          { key: 'baseDate', label: '충전일' },
          { key: 'csoEvseNum', label: '충전기' },
          { key: 'baseCost', label: '충전요금' }
        ],
        reducibleHistoryItems: [],
        recmdSuccessRateItems: [],
        recmdCostResultFields: ['기존 충전 금액', '예상 충전 금액'],
        recmdCostResultItems: [],
        savedCost: null
      };
      vm.$refs.recommendByTimeChart.updateOptions(vm.recommendByTimeChartOptions);
      vm.$refs.recommendByDayChart.updateOptions(vm.recommendByDayChartOptions);
      vm.$refs.recommendByCostChart.updateOptions(vm.recommendByCostChartOptions);

    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .tooltip-inner {
    text-align: left;
    max-width: 100%;
  }
}
</style>
